export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - MANGA PALMER.37ac2491.pdf";